// An address that belongs to no module (spec, Routing: "anything else"). Shown inside
// the shell, header included; it does not bounce to "/", which would hide a broken link
// behind a silent redirect.
import DeadEndWayOut from './DeadEndWayOut.jsx';

export default function ShellNotFound({ help }) {
  return (
    <main className="mx-auto max-w-7xl px-4 py-16 text-center sm:px-6 lg:px-8">
      <h1 className="text-lg font-semibold">Page not found</h1>
      <p className="mt-2 text-sm text-ink-secondary">There is no Adora Ops page at this address.</p>
      <DeadEndWayOut help={help} />
    </main>
  );
}
